'use client';

import Link from 'next/link';
import { api } from 'trpc/react';
import { WishlistCard } from '~/features/WishlistCard';
import IconHeart from '~/shared/assets/icons/heart.svg';
import { Spinner } from '~/shared/ui/spinner';

export default () => {
    const { data: wishlist, isSuccess, isFetching, isRefetching } = api.wishlist.getAll.useQuery(undefined, {});

    if (isFetching && !isRefetching) {
        return (
            <div className={'absolute inset-page m-auto flex size-fit items-center'}>
                <Spinner className={'size-12'} />
            </div>
        );
    }

    return (
        <>
            {isSuccess && wishlist.items.length === 0 && (
                <div
                    className={
                        '-top-8 absolute inset-page mx-auto my-auto flex h-fit max-w-[28rem] flex-col items-center gap-y-6 text-balance'
                    }
                >
                    <IconHeart className={'w-14 stroke-neutral-950'} />
                    <div className={'flex flex-col gap-y-2'}>
                        <span className={'text-center font-600 text-20 leading-tight'}>Список сохраненных пуст</span>
                    </div>
                    <Link
                        href={'/products'}
                        className={
                            'w-full bg-neutral-950 py-2 text-center font-600 text-16 text-neutral-50 uppercase outline-2 outline-neutral-950 outline-offset-2 focus-visible:outline'
                        }
                    >
                        Перейти к покупкам
                    </Link>
                </div>
            )}

            {isSuccess && wishlist.items.length > 0 && (
                <div className={'flex w-full flex-col gap-y-4'}>
                    <span className={'font-600 text-32'}>
                        <span className={'font-600'}>Избранное</span>{' '}
                        <span className={'font-400 text-28 text-neutral-400'}>({wishlist.items.length})</span>
                    </span>
                    {wishlist.items.map(wishlistItem => (
                        <WishlistCard key={wishlistItem.product.id} wishlistItem={wishlistItem} />
                    ))}
                </div>
            )}
        </>
    );
};
